import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NavigationSidebarService } from '@features/navigation/services/navigation-sidebar.service';
import { LinkComponent } from '@shared/link/link.component';

@Component({
    selector: 'app-dashboard-sidebar',
    standalone: true,
    imports: [CommonModule, LinkComponent, AsyncPipe],
    templateUrl: './dashboard-sidebar.component.html',
})
export class DashboardSidebarComponent {
    private navigationSidebarService = inject(NavigationSidebarService);

    open$ = this.navigationSidebarService.isOpen;

    openSidebar() {
        this.navigationSidebarService.toggle();
    }
}
